export default __webpack_public_path__ + "static/media/redArrow.271d5a4b.svg";